import utils from '@/mixins/utils'

/**
 * Filtra os dados
 *
 * @param {Array} cadastros
 * @param {Boolean} exibirVermelhos
 * @param {Boolean} exibirVerdes
 * @returns {Array}
 */
export function filtro(cadastros, exibirVermelhos, exibirVerdes) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.num_med_atend_pessoa == 1) {
        return true
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.num_med_atend_pessoa > 1) {
        return true
      }
    })
  }

  return cadastros_filtrados
}
